import RecaptchaFix from "../../utils/RecaptchaFix";
import BaseDeviseController from "./BaseDeviseController";

export default class PasswordEdit extends BaseDeviseController {

    constructor() {
        super();
        this.recaptchaFix = new RecaptchaFix('#update_password_form');
        this.initValidation();
        this.bindEvents();
        this.setPasswordVisibility();
        this.toggleSubmit();
    }

    bindEvents() {
        $(`#${this.resource_name}_password`).off( 'keyup', this.toggleSubmit ).on("keyup", () => this.toggleSubmit() )
        $(`#${this.resource_name}_password_confirmation`).off( 'keyup', this.toggleSubmit ).on("keyup", () => this.toggleSubmit() )
        $('#btn-update-password').on("click", () => { document.getElementById('update_password_form').reportValidity()})
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.recaptchaFix.onDestroy();
    }

    toggleSubmit() {
        let password = $(`#${this.resource_name}_password`).val().trim();
        let passwordConfirmation = $(`#${this.resource_name}_password_confirmation`).val().trim();
        if( password !== '' && passwordConfirmation !== '' ) {
            $('#btn-update-password').removeClass('disabled')
        } else {
            $('#btn-update-password').addClass('disabled')
        }
    }

    initValidation() {
        application.setTemplateValidation({
            [`${this.resource_name}[password]`]: {
                required: true,
                password_validation: true
            },
            [`${this.resource_name}[password_confirmation]`]: {
                required: true,
                equalTo: `#${this.resource_name}_password`
            },
        }, '#update_password_form')
    }
}